// @flow
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import type { Alert } from '../../../types/alert'
import type { Module } from 'vuex'
import { buildAlert } from '../../../types/alert'

export type AlertState = {
  alert: Alert
}
const initialState = (): AlertState => {
  return {
    alert: buildAlert()
  }
}

export type AlertModule = Module<AlertState>

const alertModule: AlertModule = {
  namespaced: true,
  state: initialState(),
  initialState: initialState(),
  getters,
  mutations,
  actions
}

export default alertModule



// WEBPACK FOOTER //
// ./src/store/modules/alert/index.js